<div class="backdrop" (click)="onBackdropClick($event)">
  <div class="qr-code-popup" (click)="onPopupClick($event)">
    <img [src]="qrCodeImage" alt="QR Code" *ngIf="qrCodeImage">
    <div *ngIf="!qrCodeImage" class="loading">
      Generating QR code...
    </div>
    <button class="close-button" (click)="close()" type="button" aria-label="Close">
      ×
    </button>
  </div>
</div>